import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import theme from "../../styles/theme"

const Container = styled.div`
  display: flex;
  margin: ${(props) => (props.margin ? `${props.margin}` : "0")};
  transform: ${(props) => props.flip && "rotate(180deg)"};
`

const ContainerSide = styled.div`
  display: flex;
  align-items: center;
  margin: ${(props) => (props.margin ? `${props.margin}` : "0")};
  transform: ${(props) => (props.flip ? "rotate(90deg)" : "rotate(270deg)")};
`

export const DownChevron = ({ height, width, margin, fill, flip }) => (
  <Container margin={margin} flip={flip}>
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          d="M22.8198809 3.24540251c-.661412-.45572204-1.5653416-.25591598-2.0192517.4269828-3.098261 4.67354579-7.6568157 9.07612169-9.9380384 8.72851389-2.30845727-.3503448-5.39245246-3.96875041-7.69312844-7.85812586-.44353505-.74995698-1.43046539-.94565743-2.07501779-.3831897C.27740632 4.86985312-.13111281 5.7183446.03748239 6.70505807.85841129 11.5113517 6.9693387 21.3880662 10.8625908 21.9806417c3.8919553.593944 14.4148892-12.64115445 13.0090647-17.4515537-.1413606-.48309273-.5083794-.91007554-1.0517746-1.28368549"
          fill={fill}
        />
      </g>
    </svg>
  </Container>
)

DownChevron.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
  flip: PropTypes.bool,
}

DownChevron.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
  fill: `${theme.primaryColors.primary}`,
  flip: false,
}

export const SideChevron = ({ height, width, margin, fill, flip }) => (
  <ContainerSide margin={margin} flip={flip}>
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          d="M22.8198809 3.24540251c-.661412-.45572204-1.5653416-.25591598-2.0192517.4269828-3.098261 4.67354579-7.6568157 9.07612169-9.9380384 8.72851389-2.30845727-.3503448-5.39245246-3.96875041-7.69312844-7.85812586-.44353505-.74995698-1.43046539-.94565743-2.07501779-.3831897C.27740632 4.86985312-.13111281 5.7183446.03748239 6.70505807.85841129 11.5113517 6.9693387 21.3880662 10.8625908 21.9806417c3.8919553.593944 14.4148892-12.64115445 13.0090647-17.4515537-.1413606-.48309273-.5083794-.91007554-1.0517746-1.28368549"
          fill={fill}
        />
      </g>
    </svg>
  </ContainerSide>
)

SideChevron.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
  flip: PropTypes.bool,
}

SideChevron.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
  fill: `${theme.primaryColors.primary}`,
  flip: false,
}

export const CheckIcon = ({ height, width, margin, fill }) => (
  <Container margin={margin}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        id="CheckIcon"
        d="M23.798 4.351c-.29-.362-.827-.45-1.438-.234-.41.146-4.85 4.311-13.195 12.38-1.786-1.735-5.239-5.048-6.244-5.72-1.199-.802-2.035-1-2.56-.605-.374.283-.464.805-.24 1.399.08.211.246.652 7.23 7.47.439.427.984.959 1.763.959h.01c.601-.003 1.218-.327 1.883-.988.726-.72 1.801-1.779 3.017-2.976 4.933-4.854 8.738-8.614 9.152-9.198.824-1.165 1.027-1.979.622-2.487"
      />
      <use fill={fill} fillRule="evenodd" xlinkHref="#CheckIcon" />
    </svg>
  </Container>
)

CheckIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
}

CheckIcon.defaultProps = {
  height: "14",
  width: "19",
  margin: "0",
  fill: "#000",
}

export const CloseIcon = ({ height, width, margin, fill }) => (
  <Container margin={margin}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        id="CloseIcon"
        d="M11.999 13.413c-3.737 3.722-7.369 7.264-7.816 7.444-.849.342-1.503-.054-.12-2.002.595-.84 3.42-3.761 6.524-6.856C6.865 8.263 3.323 4.63 3.143 4.183c-.342-.849.054-1.503 2.002-.12.84.595 3.764 3.423 6.86 6.53 3.678-3.63 7.333-7.102 7.846-7.363 1.063-.54 1.457.706.76 1.483-.227.253-3.58 3.668-7.203 7.293 3.63 3.677 7.1 7.332 7.362 7.845.54 1.063-.706 1.457-1.483.76-.253-.227-3.665-3.577-7.288-7.198z"
      />
      <use fill={fill} fillRule="evenodd" xlinkHref="#CloseIcon" />
    </svg>
  </Container>
)

CloseIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
}

CloseIcon.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
  fill: "#000",
}

export const BlobIcon = ({ height, width, margin, fill }) => (
  <Container margin={margin}>
    <svg
      height={height}
      width={width}
      viewBox="0 0 41 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.80899618 36.45493182c3.68051843-3.02492248 8.57455227-4.95308003 11.43401744-8.53821306 3.09671405-3.88259053.43131794-11.61030361-2.5269845-16.73423376-3.1887174-5.52302055-7.0180972-8.85242612-12.89135498-9.9711136C19.84685252.45371027 12.9096617-.1781111 8.9933385 1.67572294 1.30006072 5.31741934-.3907595 13.0598238 1.11600227 21.65074538c.392786 2.23950059-.75426243 7.92387138 3.16221116 13.1370919 6.42394038 8.55091118 14.66889353 8.95045122 23.53078275 1.66709454z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  </Container>
)

BlobIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
}

BlobIcon.defaultProps = {
  height: "41",
  width: "42",
  margin: "0",
  fill: `#313131`,
}

export const EnglishFlag = ({ height, width, margin }) => (
  <Container margin={margin}>
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#00247D"
          fillRule="nonzero"
          d="M0 4v15.9999979h23.999998V4z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M.00278549 4.00467542l-.0020784 1.80943026 9.3126049 6.20386682-9.30999371 6.1983452L8.3e-7 19.9935025l2.68192371.0043112 9.31246706-6.1959407 9.328999 6.1960482 2.6759847.0020758-.0000759-1.7669275-9.3230385-6.2150848 9.3225349-6.2052075.001199-1.81213833-2.6665799-.00063869-9.3390473 6.23308022-9.35619694-6.23003578z"
        />
        <path
          d="M11.9894032 12.0198013l1.7887613-.0085857 10.2218345 6.8303793-.0167549 1.1492669-11.9938209-7.9710589-.00002-.0000016zm10.1988815-8.01977809l1.7334381.00330833L11.9884435 12.023568l-.0007997-1.2019824 10.2007929-6.82157092-.000152.00000853zM5.09413138 8.57191106L.00000102 5.16580556V4.00000027L11.9909948 12.0170831l-1.7671679.0030949-5.12969552-3.44826907v.00000213zm6.89468802 3.44526434v1.1658048L1.78941808 19.9985005.00573528 20l11.98308412-7.9828246z"
          fill="#CF142B"
          fillRule="nonzero"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M9.33333322 4.00000108v5.33333267H.00000206v5.33333235h9.33333116v5.3333328h5.33333268v-5.3333328h9.3333317V9.33333375h-9.3333317V4.00000108z"
        />
        <path
          fill="#CF142B"
          fillRule="nonzero"
          d="M10.3999993 4.00000108v6.39999922H.00000206v3.1999991H10.3999993v6.3999995h3.2000005v-6.3999995h10.3999978v-3.1999991H13.5999998V4.00000108z"
        />
      </g>
    </svg>
  </Container>
)

EnglishFlag.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

EnglishFlag.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
}
export const GermanFlag = ({ height, width, margin }) => (
  <Container margin={margin}>
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path fill="#FFCE00" fillRule="nonzero" d="M0 4h24v16H0z" />
        <path fill="#D00" fillRule="nonzero" d="M0 4h24v11H0z" />
        <path fill="#000" fillRule="nonzero" d="M0 4h24v5H0z" />
      </g>
    </svg>
  </Container>
)

GermanFlag.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

GermanFlag.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
}

export const GhanaFlag = ({ height, width, margin }) => (
  <Container margin={margin}>
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path fill="#006B3F" d="M0 21h24V3H0z" />
        <path fill="#FCD116" d="M0 15h24V3H0z" />
        <path fill="#CE1126" d="M0 9h24V3.0000375H0z" />
        <path
          fill="#000"
          d="M13.2044662 12.70605375l1.9455375-1.4148h-2.4053624l-.7446376-2.29125-.7446749 2.29125H8.84625375l1.94883755 1.41615-.7450876 2.29259995 1.9492876-1.4175375 1.9507124 1.4175375z"
        />
      </g>
    </svg>
  </Container>
)

GhanaFlag.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

GhanaFlag.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
}
export const DutchFlag = ({ height, width, margin }) => (
  <Container margin={margin}>
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path fill="#21468B" fillRule="nonzero" d="M0 4h24v16H0z" />
        <path fill="#FFF" fillRule="nonzero" d="M0 4h24v11H0z" />
        <path fill="#AE1C28" fillRule="nonzero" d="M0 4h24v5H0z" />
      </g>
    </svg>
  </Container>
)

DutchFlag.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

DutchFlag.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
}

export const FacebookIcon = ({ height, width, margin }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        height={height}
        width={width}
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.8276196 35.0102679c-8.4167554 7.0847535-16.2475634 6.6961081-22.34882837-1.6216361C.75904265 28.3175659 1.8484747 22.7881971 1.47541837 20.6097633c-1.4310769-8.3566635.17481319-15.88794735 7.48165655-19.43034165C12.6766807-.62386189 19.2654154-.00926905 23.0434305.7277321c5.5782433 1.08818298 9.2152728 4.32680205 12.2438205 9.6992204 2.8097065 4.9842103 5.3412194 12.5012035 2.4000537 16.2779231-2.7158338 3.4873733-7.3640397 5.3629537-10.8596851 8.3053923zm-.7618101-25.73355637H10.8563914c-.5208341 0-.94321968.43259736-.94321968.96602337v15.5771276c0 .533426.42238558.9660234.94321968.9660234h8.1942214v-6.7712204h-2.225409v-2.6505267h2.225409V15.413979c0-2.2610985 1.3499832-3.4927784 3.3189544-3.4927784.6634961-.0015094 1.3266975.0329052 1.9866566.10264v2.3637385h-1.3555836c-1.0732072 0-1.2824841.5192376-1.2824841 1.2860187V17.36112h2.5643786l-.3330744 2.6505267h-2.246042v6.7742392h4.3623912c.5211289 0 .9432197-.4325974.9432197-.9660234V10.2427349c0-.53342601-.4220908-.96602337-.9432197-.96602337z"
          fill="white"
          fillRule="evenodd"
        />
      </svg>
    </Container>
  </React.Fragment>
)

FacebookIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

FacebookIcon.defaultProps = {
  height: "40",
  width: "40",
  margin: "0",
}

export const InstagramIcon = ({ height, width, margin }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        height={height}
        width={width}
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7908718 34.8034827C1.37804052 31.1378725-2.38346709 24.2039661 1.49076597 14.7556974 3.85276351 8.99538627 9.1166016 7.14160992 10.771251 5.72098901 17.1186319.27136221 24.3520071-2.14858206 31.17734 2.35017248c3.4744891 2.29012621 6.3951946 8.26939202 7.7434119 11.89206952 1.9906442 5.3488871 1.1412382 10.1130357-1.8377602 15.4307468-2.7637376 4.9334563-7.8232477 10.9060597-12.5665292 10.2818721-4.3798838-.5763667-8.4009353-3.6289776-12.7255907-5.1513782zM22.196833 15.184518c-.8000517 0-1.5420345.1979087-2.2259497.5937254-.6839152.3958168-1.2258855.9320849-1.6259111 1.6088044-.4000255.6767195-.6000386 1.4108957-.6000386 2.2025298 0 .7916341.2000131 1.5258103.6000386 2.2025298.4000256.6767194.9419959 1.2129876 1.6259111 1.6088043.6839152.3958168 1.425898.5937254 2.2259497.5937254s1.5420345-.1979086 2.2259497-.5937254c.6839152-.3958167 1.2258855-.9320849 1.6259111-1.6088043.4000255-.6767195.6000386-1.4108957.6000386-2.2025298 0-.7916341-.2000131-1.5258103-.6000386-2.2025298-.4000256-.6767195-.9419959-1.2129876-1.6259111-1.6088044-.6839152-.3958167-1.425898-.5937254-2.2259497-.5937254zm0 7.2779245c-.8000517 0-1.4839663-.2809021-2.051745-.842707-.5677786-.5618049-.8516677-1.2385238-.8516677-2.0301579 0-.7916341.2838891-1.468353.8516677-2.0301579.5677787-.5618049 1.2516933-.8427071 2.051745-.8427071s1.4839663.2809022 2.0517449.8427071c.5677787.5618049.8516677 1.2385238.8516677 2.0301579 0 .7916341-.283889 1.468353-.8516677 2.0301579-.5677786.5618049-1.2516932.842707-2.0517449.842707zm5.6906888-7.4694488c0-.2809022-.1032327-.5235001-.3096974-.7277925-.2064647-.2042924-.4516421-.3064389-.7355312-.3064389-.283889 0-.5290665.1021465-.7355312.3064389-.2064647.2042924-.3096973.4468903-.3096973.7277925 0 .2809021.1032326.5235.3096973.7277924.2064647.2042924.4516422.3064389.7355312.3064389.2838891 0 .5226143-.1021465.7161751-.3064389.1935609-.2042924.3032452-.4468903.3290535-.7277924zm2.9421248 1.0342313c-.051616-.7405605-.1677525-1.3789751-.3484095-1.9152433-.232273-.6384146-.5871348-1.1938351-1.0645847-1.6662616-.4774498-.4724265-1.0387763-.8235546-1.6839793-1.0533838-.5419704-.1787563-1.1807211-.2872865-1.9162523-.3255914-.7355312-.0383049-1.9420607-.0574573-3.6195878-.0574573s-2.8840566.0191524-3.6195878.0574573-1.374282.1468351-1.9162523.3255914c-.645203.2298292-1.2065295.5809573-1.6839794 1.0533838-.4774498.4724265-.8323116 1.027847-1.0645846 1.6662616-.180657.5362682-.2903413 1.1682985-.3290534 1.8960909-.0387122.7277925-.0580683 1.9216276-.0580683 3.581505 0 1.6598773.0193561 2.8537125.0580683 3.5815049.0387121.7277925.1483964 1.3598228.3290534 1.8960909.232273.6384146.5871348 1.1938352 1.0645846 1.6662617.4774499.4724264 1.0387764.8107865 1.6839794 1.0150789.5419703.2042924 1.1807211.3255914 1.9162523.3638962.7355312.0383049 1.9420607.0574573 3.6195878.0574573s2.8840566-.0191524 3.6195878-.0574573c.7355312-.0383048 1.3742819-.1468351 1.9162523-.3255913.645203-.2298292 1.2065295-.5809574 1.6839793-1.0533838.4774499-.4724265.8323117-1.0278471 1.0645847-1.6662617.180657-.5362681.2903412-1.1682984.3290534-1.8960909.0387122-.7277924.0580683-1.9216276.0580683-3.5815049 0-1.6598774-.0129039-2.8473282-.0387122-3.5623526zm-1.8581841 8.6185949c-.3096973.7660973-.8645716 1.3151335-1.6646233 1.6471092-.4129299.1532195-1.109749.255366-2.0904571.3064389-.5419703.0255368-1.342022.0383049-2.4001544.0383049h-1.2387894c-1.0323247 0-1.8323758-.0127681-2.4001545-.0383049-.9549003-.0510729-1.6517194-.1532194-2.0904571-.3064389-.7742433-.3064389-1.3291176-.8554751-1.6646232-1.6471092-.1548487-.4341217-.2580813-1.1236092-.3096974-2.0684628-.0258083-.5618049-.0387121-1.3534384-.0387121-2.3749017v-1.2257557c0-1.0214633.0129038-1.8130968.0387121-2.3749017.0516161-.9703897.1548487-1.6598773.3096974-2.0684627.3096973-.7916341.8645715-1.3406703 1.6646232-1.6471093.4387377-.1532194 1.1355568-.2553659 2.0904571-.3064389.5677787-.0255368 1.3678298-.0383049 2.4001545-.0383049h1.2387894c1.0323247 0 1.8323758.0127681 2.4001544.0383049.9807081.051073 1.6775272.1532195 2.0904571.3064389.8000517.306439 1.354926.8554752 1.6646233 1.6471093.1548487.4085854.2580813 1.098073.3096973 2.0684627.0258084.5362682.0387122 1.3279022.0387122 2.3749017v1.2257557c0 1.0214633-.0129038 1.8130968-.0387122 2.3749017-.051616.9448536-.1548486 1.6343411-.3096973 2.0684628z"
          fill="white"
          fillRule="evenodd"
        />
      </svg>
    </Container>
  </React.Fragment>
)

InstagramIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

InstagramIcon.defaultProps = {
  height: "40",
  width: "40",
  margin: "0",
}

export const YoutubeIcon = ({ height, width, margin }) => {
  const YoutubeWrapper = styled.div`
    position: relative;
    .blob-icon {
    }

    .youtube-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `

  return (
    <React.Fragment>
      <Container margin={margin}>
        <YoutubeWrapper>
          <BlobIcon className="blob-icon" height="32" width="32" fill="white" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height={height}
            width={width}
            viewBox="0 0 24 24"
            className="youtube-icon"
          >
            <path d="M21 5s-3-1-9-1-9 1-9 1-1 3-1 7 1 7 1 7 3 1 9 1 9-1 9-1 1-3 1-7-1-7-1-7zM10 15.464V8.536L16 12l-6 3.464z"></path>
          </svg>
        </YoutubeWrapper>
      </Container>
    </React.Fragment>
  )
}

YoutubeIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fil: PropTypes.string,
}

YoutubeIcon.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
}

export const StarFull = ({ height, width, margin, fill }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        className="svg-icon"
      >
        <g fill="none" fillRule="evenodd">
          <g fill={fill}>
            <g>
              <path
                d="M14.43 10L12 2 9.57 10 2 10 8.18 14.41 5.83 22 12 17.31 18.18 22 15.83 14.41 22 10z"
                transform="translate(-216.000000, -672.000000) translate(216.000000, 672.000000)"
              />
            </g>
          </g>
        </g>
      </svg>
    </Container>
  </React.Fragment>
)
StarFull.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
}
StarFull.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
  fill: `${theme.colors.yellow800}`,
}

export const StarGrey = ({ height, width, margin, fill }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        className="svg-icon"
      >
        <g fill="none" fillRule="evenodd">
          <g fill={fill}>
            <g>
              <path
                d="M14.43 10L12 2 9.57 10 2 10 8.18 14.41 5.83 22 12 17.31 18.18 22 15.83 14.41 22 10z"
                transform="translate(-216.000000, -672.000000) translate(216.000000, 672.000000)"
              />
            </g>
          </g>
        </g>
      </svg>
    </Container>
  </React.Fragment>
)
StarGrey.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
}
StarGrey.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
  fill: `#393939`,
}
export const StarHalf = ({ height, width, margin, fill }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        className="svg-icon"
      >
        <g fill="none" fillRule="evenodd">
          <g>
            <g>
              <path
                fill="#393939"
                d="M14.43 10L12 2 9.57 10 2 10 8.18 14.41 5.83 22 12 17.31 18.18 22 15.83 14.41 22 10z"
                transform="translate(-264.000000, -672.000000) translate(264.000000, 672.000000)"
              />
              <path
                fill={fill}
                d="M12 2v15.31L5.83 22l2.35-7.59L2 10h7.57L12 2z"
                transform="translate(-264.000000, -672.000000) translate(264.000000, 672.000000)"
              />
            </g>
          </g>
        </g>
      </svg>
    </Container>
  </React.Fragment>
)
StarHalf.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
}
StarHalf.defaultProps = {
  height: "24",
  width: "24",
  margin: "0",
  fill: `${theme.colors.yellow800}`,
}

export const QuotationIcon = ({ height, width, margin }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        height={height}
        width={width}
        viewBox="0 0 185 141"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h185v141H0z" />
          <path
            d="M33.73656667 38.34566821c2.81286422-3.52391702 23.93841256-13.85167816 36.31233064-5.36590246-7.66047153 14.61873606-11.8149245 22.7974551-11.8507009 36.00622828l4.54798529-.13953894c14.20295084.1974769 17.30649209 4.35404167 28.437204 27.17119863 16.80563064 35.9411807-52.47400254 38.33817406-60.49222962 31.70895736-25.32024709-20.30114009-13.7289194-67.87874232 3.04541059-89.38094287zm85.6731053-23.91503459c2.7801475-3.50662449 23.68967294-13.76001016 35.96379598-5.2806539-7.56213628 14.5543736-11.66279827 22.69732536-11.67394309 35.8606098 1.5017701-.04356424 3.00354118-.08712866 4.50531127-.1306929 14.07085209.22292383 17.15309414 4.37090379 28.22196832 27.13007133 21.46756819 35.25984704-51.91408517 38.1098107-59.86972602 31.4886406-25.121443-20.27790388-13.72573958-67.67057265 2.85259354-89.06797493z"
            fill="#F46A4C"
          />
        </g>
      </svg>
    </Container>
  </React.Fragment>
)

QuotationIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

QuotationIcon.defaultProps = {
  height: "141",
  width: "185",
  margin: "0",
}

export const TeamworkIcon = ({ height, width, margin }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        height={height}
        width={width}
        viewBox="0 0 112 112"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h112v112H0z" />
          <path
            d="M69.2651257 83.1244898c9.8697556-1.6367411 20.7948722-.0046558 29.7596377-3.5223317C108.733333 75.7926218 112 58.9399245 112 46.5150542c0-13.3926131-3.468438-23.4684965-12.9752366-31.6699218C92.586029 9.29049671 80.6330962.85738232 71.5641361.11672442 53.7489495-1.33823387 42.544409 10.9671547 36.2642186 28.1731627c-1.637134 4.4853007-9.6918068 13.6187997-8.0429805 27.212138C30.925702 77.6815814 45.5008966 87.065407 69.2651257 83.1244898z"
            fill="#FEC20D"
          />
          <path
            d="M64.758 45.887c-1.036 0-1.875.84-1.875 1.875v52.487h-6.679v-26.09c0-1.036-.84-1.876-1.876-1.876-1.035 0-1.875.84-1.875 1.876v26.09h-5.731V47.762c0-1.035-.84-1.875-1.876-1.875-1.035 0-1.875.84-1.875 1.875v23.933c-3.387-.307-6.047-3.056-6.047-6.391V47.131c0-3.246.944-6.405 2.73-9.136 3.272-5.004 8.876-7.992 14.99-7.992 6.125 0 11.734 2.995 15.004 8.012 1.777 2.727 2.716 5.879 2.716 9.116v18.173c0 3.231-2.495 5.911-5.731 6.355V47.762c0-1.035-.839-1.875-1.875-1.875M46.801 19.001c0-3.998 3.252-7.25 7.25-7.25 3.999 0 7.251 3.252 7.251 7.25s-3.252 7.251-7.251 7.251c-3.997 0-7.25-3.253-7.25-7.251m53.436 81.248H84.135l-.099-46.082c-.002-1.034-.841-1.871-1.875-1.871h-.004c-1.036.002-1.874.843-1.871 1.879l.098 46.074h-5.446l-.049-20.503c-.002-1.034-.841-1.871-1.875-1.871h-.004c-1.036.003-1.874.845-1.871 1.88l.048 20.494h-4.554V75.431c5.309-.469 9.482-4.831 9.482-10.127V47.13c0-2.889-.613-5.722-1.786-8.338 3.704.247 7.151 1.754 9.803 4.315 2.902 2.802 4.505 6.529 4.513 10.494l.034 10.672c.004 1.034.843 1.87 1.876 1.87h.006c1.035-.004 1.872-.846 1.869-1.881l-.034-10.67c-.011-4.988-2.02-9.669-5.659-13.183-2.078-2.007-4.546-3.493-7.237-4.395 1.906-1.814 3.095-4.373 3.089-7.205-.012-5.464-4.461-9.901-9.922-9.901h-.022c-1.591.003-3.173.393-4.575 1.127-.917.48-1.272 1.613-.792 2.531.481.918 1.614 1.272 2.531.792.883-.462 1.84-.698 2.845-.7 3.408-.001 6.177 2.756 6.185 6.159.007 3.403-2.756 6.178-6.159 6.185-.081 0-.16.007-.237.017-.101.004-.2.008-.3.014-2.71-3.709-6.513-6.398-10.845-7.763 2.299-2.018 3.756-4.975 3.756-8.269C65.053 12.935 60.118 8 54.052 8 47.986 8 43.05 12.935 43.05 19.001c0 3.453 1.601 6.538 4.097 8.556-3.977 1.435-7.462 4.006-9.993 7.465-.297-.013-.593-.021-.888-.021-.141 0-.28.002-.42.005-.035-.002-.068-.005-.103-.005-3.403 0-6.172-2.769-6.172-6.172 0-3.403 2.769-6.171 6.172-6.171 1.029 0 2.046.257 2.942.744.91.495 2.049.158 2.544-.752.494-.909.158-2.048-.752-2.543-1.445-.785-3.082-1.2-4.734-1.2-5.471 0-9.923 4.451-9.923 9.922 0 2.979 1.322 5.654 3.408 7.475-7.09 2.733-12.116 9.471-12.116 17.328v10.635c0 1.036.839 1.876 1.875 1.876s1.875-.84 1.875-1.876V53.632c0-7.777 6.209-14.176 14.089-14.823-1.167 2.611-1.777 5.437-1.777 8.321v18.174c0 5.401 4.339 9.831 9.797 10.151v24.794h-5.109V79.75c0-1.036-.839-1.875-1.875-1.875s-1.875.839-1.875 1.875v20.499h-4.61V54.19c0-1.036-.84-1.876-1.876-1.876-1.035 0-1.875.84-1.875 1.876v46.059H10.875c-1.036 0-1.875.84-1.875 1.875 0 1.036.839 1.876 1.875 1.876h89.362c1.036 0 1.875-.84 1.875-1.876 0-1.035-.84-1.875-1.875-1.875"
            fill="#000"
          />
        </g>
      </svg>
    </Container>
  </React.Fragment>
)

TeamworkIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

TeamworkIcon.defaultProps = {
  height: "88",
  width: "88",
  margin: "0",
}

export const MakeADifference = ({ height, width, margin }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        width={width}
        viewBox="0 0 112 112"
      >
        <g fill="none" fillRule="evenodd">
          <path
            fill="#FEC20D"
            d="M36.353 111.229c8.694-1.442 18.319-.004 26.216-3.103C71.122 104.77 74 89.923 74 78.978c0-11.799-3.056-20.675-11.43-27.9-5.673-4.894-16.203-12.323-24.192-12.975C22.684 36.82 12.813 47.662 7.28 62.819 5.838 66.771-1.258 74.817.195 86.792c2.382 19.642 15.222 27.908 36.158 24.437z"
          />
          <path
            fill="#000"
            d="M92.6 32.561v-3.184h-9.158a6.569 6.569 0 0 0-6.561 6.562v3.184h9.157A6.57 6.57 0 0 0 92.6 32.56zm-19.47-6.933v-3.275c0-5.294-4.308-9.602-9.602-9.602H52.893v3.273c0 5.296 4.31 9.604 9.604 9.604H73.13zm21.344 0c1.036 0 1.876.839 1.876 1.875v5.058c0 5.686-4.626 10.311-10.312 10.311h-9.157v6.064a23.344 23.344 0 0 1 15.163 11.43 1.875 1.875 0 0 1-3.28 1.817 19.599 19.599 0 0 0-13.92-9.832 1.694 1.694 0 0 1-.247-.038 19.62 19.62 0 0 0-2.959-.228 19.426 19.426 0 0 0-11.43 3.684 1.874 1.874 0 1 1-2.192-3.041 23.146 23.146 0 0 1 15.114-4.343V29.377H62.497c-7.364 0-13.353-5.989-13.353-13.353v-5.15c0-1.035.84-1.874 1.874-1.874h12.51C70.89 9 76.88 14.99 76.88 22.353v5.638a10.26 10.26 0 0 1 6.561-2.363h11.032zM33.583 87.162a.996.996 0 0 0-.018-.765l-.482-1.095-.003-.004-8.82-19.976a.995.995 0 0 0-.553-.528.99.99 0 0 0-.766.018L11.75 69.716V86.09l3.892-1.912a1.876 1.876 0 0 1 1.653 3.367l-5.545 2.724v8.207l21.216-10.718c.03-.014.059-.03.09-.041.244-.11.43-.305.528-.555zm69.79-17.31c1.636 3.706-.048 8.053-3.753 9.69L74.55 90.61a18.272 18.272 0 0 1-15.554-.352L49.819 85.7a14.537 14.537 0 0 0-12.371-.282l-.224.099c.279.985.232 2.03-.144 3a4.722 4.722 0 0 1-2.461 2.608L10.72 103.197A1.873 1.873 0 0 1 8 101.524V68.49c0-.745.44-1.418 1.121-1.717l12.311-5.393a4.712 4.712 0 0 1 3.63-.083 4.72 4.72 0 0 1 2.257 1.833l9.584-4.23a22.672 22.672 0 0 1 17.058-.544l18.455 6.776c3.581 1.316 5.49 5.322 4.256 8.933-1.004 2.932-3.761 4.785-6.705 4.785-.75 0-1.511-.12-2.258-.373L53.44 73.65a1.875 1.875 0 1 1 1.201-3.552l14.27 4.827a3.332 3.332 0 0 0 4.213-2.075 3.344 3.344 0 0 0-2-4.198l-18.455-6.778a18.946 18.946 0 0 0-14.252.456l-9.521 4.204 6.857 15.534.181-.08a18.272 18.272 0 0 1 15.554.353l9.177 4.559a14.532 14.532 0 0 0 12.37.28l25.071-11.07a3.602 3.602 0 0 0 1.838-4.744 3.602 3.602 0 0 0-4.732-1.842l-12.236 5.64a1.876 1.876 0 0 1-1.57-3.405l12.251-5.649.028-.012c3.705-1.636 8.053.047 9.69 3.754z"
          />
        </g>
      </svg>
    </Container>
  </React.Fragment>
)

MakeADifference.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

MakeADifference.defaultProps = {
  height: "88",
  width: "88",
  margin: "0",
}

export const ChallengeYourself = ({ height, width, margin }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        width={width}
        viewBox="0 0 112 112"
      >
        <g fill="none" fillRule="evenodd">
          <path
            fill="#FEC20D"
            d="M36.353 92.229c8.694-1.442 18.319-.004 26.216-3.103C71.122 85.77 74 70.923 74 59.978c0-11.799-3.056-20.675-11.43-27.9-5.673-4.894-16.203-12.323-24.192-12.975C22.684 17.82 12.813 28.662 7.28 43.819 5.838 47.771-1.258 55.817.195 67.792 2.577 87.434 15.417 95.7 36.353 92.229z"
          />
          <path
            fill="#000"
            d="M84.9 70.857a1.875 1.875 0 1 1-3.12 2.08L77.489 66.5l-1.97 2.954a1.874 1.874 0 1 1-3.12-2.08l2.216-3.323a3.448 3.448 0 0 1 2.874-1.538c1.158 0 2.233.575 2.874 1.538l4.537 6.805zM11.745 100.26l70.999-.01-35.497-53.245-35.496 53.245-.006.01zm37.128-88.51V35h6.961v-.476c0-4.101 2.64-7.596 6.309-8.88a5.959 5.959 0 0 1-.684-2.777v-.75c0-3.308 2.692-6 6-6 3.309 0 6 2.692 6 6v.75a5.97 5.97 0 0 1-.683 2.777c3.669 1.284 6.309 4.779 6.309 8.88V35h8.379l-3.92-10.995a1.88 1.88 0 0 1 0-1.26l3.92-10.995H48.873zm16.336 11.117c0 1.241 1.01 2.25 2.25 2.25a2.252 2.252 0 0 0 2.25-2.25v-.75c0-1.24-1.009-2.25-2.25-2.25-1.24 0-2.25 1.01-2.25 2.25v.75zM75.335 35v-.476a5.664 5.664 0 0 0-5.657-5.657H65.24a5.663 5.663 0 0 0-5.656 5.657V35h15.751zm28.08 63.63a3.447 3.447 0 0 1 .171 3.546A3.449 3.449 0 0 1 100.54 104H11.751a3.743 3.743 0 0 1-3.306-1.981 3.741 3.741 0 0 1 .186-3.849l35.496-53.245a3.748 3.748 0 0 1 1.018-1.025 1.925 1.925 0 0 1-.022-.275V9.875c0-1.036.839-1.875 1.875-1.875h43.125a1.875 1.875 0 0 1 1.766 2.505l-4.588 12.87 4.588 12.87a1.877 1.877 0 0 1-1.766 2.505h-41.25v4.876c.596.287 1.115.73 1.495 1.299l36.883 55.325h12.738L89.716 84.833a1.875 1.875 0 1 1 3.121-2.079l10.578 15.876zM42.01 67.049c.35.349.55.833.55 1.326 0 .493-.2.977-.55 1.325a1.89 1.89 0 0 1-1.326.55c-.493 0-.976-.201-1.325-.55a1.886 1.886 0 0 1-.55-1.325c0-.493.201-.977.55-1.326a1.887 1.887 0 0 1 1.325-.549c.493 0 .977.2 1.326.549zm-3.942 5.018a1.876 1.876 0 0 1 .52 2.6l-9.22 13.83a1.873 1.873 0 0 1-2.6.52 1.875 1.875 0 0 1-.52-2.6l9.22-13.83a1.876 1.876 0 0 1 2.6-.52z"
          />
        </g>
      </svg>
    </Container>
  </React.Fragment>
)

ChallengeYourself.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

ChallengeYourself.defaultProps = {
  height: "88",
  width: "88",
  margin: "0",
}

export const Network = ({ height, width, margin }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        width={width}
        viewBox="0 0 112 112"
      >
        <g fill="none" fillRule="evenodd">
          <path
            fill="#FEC20D"
            d="M47.16 111c11.28-1.871 23.766-.006 34.011-4.026C92.267 102.62 96 83.36 96 69.16c0-15.306-3.964-26.821-14.829-36.194-7.358-6.348-21.019-15.986-31.383-16.833-20.36-1.662-33.166 12.4-40.343 32.065-1.871 5.126-11.077 15.564-9.192 31.1 3.09 25.48 19.748 36.205 46.907 31.701z"
          />
          <path
            fill="#000"
            d="M82.478 34.368c8.354-.09 15.15-6.96 15.15-15.315 0-8.446-6.87-15.317-15.317-15.317H45.14c-8.446 0-15.317 6.871-15.317 15.317S36.693 34.37 45.14 34.37c1.031 0 1.867.836 1.867 1.868v3.896l5.218-5.217c.35-.35.825-.547 1.32-.547h20.547c.496 0 .971.197 1.321.547l5.217 5.217v-3.899c0-1.024.825-1.857 1.848-1.867zM82.311 0c10.506 0 19.053 8.547 19.053 19.053 0 5.053-1.958 9.813-5.513 13.403a18.922 18.922 0 0 1-11.485 5.54v6.647a1.868 1.868 0 0 1-3.189 1.321l-7.858-7.858h-19l-7.859 7.858a1.868 1.868 0 0 1-3.188-1.32v-6.63c-9.632-.94-17.185-9.086-17.185-18.961C26.087 8.547 34.634 0 45.14 0H82.31zM63.843 26.898c4.326 0 7.845-3.52 7.845-7.845 0-.467-.043-.924-.122-1.37l-4.839 4.839a1.862 1.862 0 0 1-1.32.547c-.479 0-.957-.182-1.321-.547l-3.27-3.269a1.868 1.868 0 0 1 2.643-2.642l1.948 1.948 4.49-4.49a7.833 7.833 0 0 0-6.054-2.861c-4.326 0-7.846 3.519-7.846 7.845s3.52 7.845 7.846 7.845zm12.691-16.824c.73.73.73 1.912 0 2.641l-1.969 1.969c.552 1.349.859 2.824.859 4.369 0 6.386-5.195 11.581-11.581 11.581-6.386 0-11.582-5.195-11.582-11.581 0-6.386 5.196-11.581 11.582-11.581 3.464 0 6.576 1.531 8.7 3.95l1.35-1.348c.729-.73 1.912-.73 2.641 0zM50.37 91.902v-15.07c0-5.591-4.55-10.14-10.141-10.14H36.92v4.713a1.868 1.868 0 1 1-3.736 0V66.69h-3.308c-5.592 0-10.141 4.55-10.141 10.142v15.069H50.37zM29.147 53.74v3.31a5.913 5.913 0 0 0 5.906 5.905 5.913 5.913 0 0 0 5.906-5.906v-3.31a5.913 5.913 0 0 0-5.906-5.906 5.913 5.913 0 0 0-5.906 5.907zm13.368 9.407c6.567 1.094 11.59 6.813 11.59 13.686V93.77a1.868 1.868 0 0 1-1.867 1.868h-34.37A1.868 1.868 0 0 1 16 93.77V76.833c0-6.873 5.023-12.592 11.59-13.686a9.597 9.597 0 0 1-2.18-6.098v-3.31c0-5.316 4.326-9.641 9.643-9.641 5.317 0 9.642 4.325 9.642 9.642v3.31a9.597 9.597 0 0 1-2.18 6.097zm65.387 28.755v-15.07c0-5.591-4.55-10.14-10.141-10.14h-3.308v4.713a1.868 1.868 0 1 1-3.736 0V66.69h-3.308c-5.592 0-10.141 4.55-10.141 10.142v15.069h30.634zM86.679 53.74v3.31a5.913 5.913 0 0 0 5.906 5.905 5.913 5.913 0 0 0 5.906-5.906v-3.31a5.913 5.913 0 0 0-5.906-5.906 5.913 5.913 0 0 0-5.906 5.907zm13.368 9.407c6.568 1.094 11.59 6.813 11.59 13.686V93.77a1.868 1.868 0 0 1-1.867 1.868H75.4a1.868 1.868 0 0 1-1.868-1.868V76.833c0-6.873 5.023-12.592 11.59-13.686a9.597 9.597 0 0 1-2.18-6.098v-3.31c0-5.316 4.326-9.641 9.643-9.641 5.317 0 9.642 4.325 9.642 9.642v3.31a9.597 9.597 0 0 1-2.18 6.097z"
          />
        </g>
      </svg>
    </Container>
  </React.Fragment>
)

Network.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

Network.defaultProps = {
  height: "88",
  width: "88",
  margin: "0",
}

export const AccommodationFood = ({ height, width, margin }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        height={height}
        width={width}
        viewBox="0 0 112 112"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h112v112H0z" />
          <path
            d="M69.4024324 107.112977v-5.593h6.5928334c1.351 0 2.4441666-1.0955 2.4441666-2.4441662 0-1.3486667-1.0931666-2.443-2.4441666-2.443h-6.5928334v-23.345c0-1.7185-1.3965-3.115-3.1138333-3.115H45.6432658c-1.7185 0-3.1138334 1.3965-3.1138334 3.115v33.8251662H8.60043244l3.11616666-5.593h6.8635c1.3486667 0 2.443-1.0955 2.443-2.4441662 0-1.3486667-1.0943333-2.443-2.443-2.443h-4.1416667l15.9705-28.6755h7.028c1.3486667 0 2.443-1.0931667 2.443-2.443s-1.0943333-2.443-2.443-2.443h-4.3061666l7.5938333-13.636h6.8051667c1.3486666 0 2.4441666-1.0943333 2.4441666-2.443s-1.0955-2.4441667-2.4441666-2.4441667h-4.0833334l12.5183334-22.4758333 28.0618333 50.3836667h-5.0225c-1.3486667 0-2.4418333 1.0931666-2.4418333 2.4441666 0 1.3486667 1.0931666 2.4418334 2.4418333 2.4418334h7.7186667c.0081666 0 .0163333-.0011667.0256666-.0011667l16.5818336 29.7721662H69.4024324zm-21.9881666-.295166h17.101V75.0588108h-17.101v31.7590002zm11.3481666-89.7680002l7.4725-13.41783334c.6568334-1.17833333.2333334-2.66583333-.945-3.32266667-1.1783333-.65683333-2.6681666-.23333333-3.3238333.94616667L55.9647658 12.0296441 49.9645991 1.25547746c-.6568333-1.1795-2.1443333-1.603-3.3238333-.94616667-1.1783334.65683334-1.6018334 2.14433334-.945 3.32266667l7.4725 13.41783334L2.30859911 108.368311c-.42116667.756-.41066667 1.68.028 2.426666.43983333.746667 1.24016667 1.205167 2.10583333 1.205167H107.489432c.8645 0 1.666-.4585 2.104667-1.205167.439833-.746666.450333-1.670666.029167-2.426666L58.7624324 17.0498108z"
            fill="#000"
          />
        </g>
      </svg>
    </Container>
  </React.Fragment>
)

AccommodationFood.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
}

AccommodationFood.defaultProps = {
  height: "64",
  width: "64",
  margin: "0",
}

export const WhatsAppIcon = ({ height, width, margin, fill }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        height={height}
        width={width}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h24v24H0z" />
          <path
            d="M24 11.6909333c0 6.4568-5.2744 11.6909334-11.7818667 11.6909334-2.0658666 0-4.00666663-.528-5.69519997-1.4546667L0 24l2.12666667-6.2725333C1.05386667 15.9658667.436 13.8997333.436 11.6909333.436 5.23413333 5.71093333 0 12.2181333 0 18.7261333 0 24 5.23413333 24 11.6909333zM12.2181333 1.86186667c-5.46239997 0-9.90559997 4.40933333-9.90559997 9.82906663 0 2.1506667.70106667 4.1424 1.88693334 5.7626667l-1.2376 3.6504 3.80666666-1.2098667C8.33253333 20.9210667 10.2061333 21.52 12.2184 21.52c5.4616 0 9.9056-4.4088 9.9056-9.8285333 0-5.41973337-4.4437333-9.82960003-9.9058667-9.82960003zm5.9496 12.52160003c-.0728-.1192-.2650666-.1912-.5536-.3344-.2890666-.1432-1.7093333-.8368-1.9733333-.932-.2648-.0954667-.4578667-.1434667-.6501333.1432-.1922667.2869333-.7458667.932-.9146667 1.1232-.1685333.1917333-.3368.2157333-.6258667.0722666C13.1616 14.3125333 12.2312 14.0096 11.128 13.0336c-.8584-.7594667-1.43813333-1.6970667-1.60666667-1.9842667-.16826666-.2866666-.0176-.4416.12666667-.5842666.13013333-.1285334.28906667-.3346667.4333333-.5018667.1448-.16746667.1928-.28666667.2885334-.47813333.0968-.1912.0485333-.3584-.024-.50213334-.072-.1432-.65013337-1.55333333-.8906667-2.1272-.24053333-.57333333-.4808-.47786666-.6496-.47786666-.16826667 0-.36106667-.024-.5536-.024s-.5056.07173333-.7704.3584C7.21706667 6.9992 6.4712 7.69253333 6.4712 9.1024c0 1.4101333 1.0344 2.7725333 1.1792 2.9634667.14426667.1909333 1.99733333 3.1786666 4.9333333 4.3261333C15.52 17.5389333 15.52 17.1562667 16.0496 17.1082667c.5290667-.0477334 1.7082667-.6930667 1.9498667-1.3618667.24-.6698667.24-1.2434667.1682666-1.3629333z"
            fill={fill}
          />
        </g>
      </svg>
    </Container>
  </React.Fragment>
)

WhatsAppIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
}

WhatsAppIcon.defaultProps = {
  height: "16",
  width: "16",
  margin: "0",
  fill: `${theme.colors.green800}`,
}

export const LgaServices = ({ height, width, margin, fill }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        height={height}
        width={width}
        viewBox="0 0 112 112"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h112v112H0z" />
          <path
            d="M59.3892807 20.8599159c-2.4441667 5.187-1.0838334 10.367.1155 13.2755l17.1581666-15.092c.9158334-.805 2.31-.7151667 3.1138334.1995.805.9146667.7163333 2.3088333-.1983334 3.1138333l-15.1725 13.3443334c13.2335.0618333 22.3498334-3.122 27.1401667-9.4943334 5.6245-7.4806666 3.7683333-17.63066662 2.7346667-21.58099995-19.0061667 2.48733333-31.0531667 8.08616665-34.8915 16.23416665zm-36.7465 38.5735c5.2908333 4.0576667 13.3606666 4.5966667 24.0275 1.6193333L34.660614 55.8214159c-1.1165-.4865-1.6275-1.7873333-1.1421667-2.9038333.4876667-1.1176667 1.7873334-1.6286667 2.905-1.141l14.0653334 6.1261666c.175-2.6868333-.182-6.6371666-2.9855-9.8618333-4.9571667-5.7015-15.9868334-7.5168333-31.9585-5.2768333.0921666 3.6155.9963333 11.991 7.098 16.6693333zm45.5163333.623c-1.5995 1.8515-2.0125 4.0378333-2.0276667 5.7586667l9.3193334-4.0588334c1.1165-.4865 2.4161666.0245 2.9038333 1.1421667.4865 1.1165-.0245 2.4161667-1.1421667 2.9026667l-7.0163333 3.0578333c6.6441667 1.5796667 11.7016667 1.0745 15.071-1.519 3.9258333-3.0205 4.7133333-8.2623333 4.8451667-10.9771667-11.0168334-1.4735-18.5896667-.2065-21.9531667 3.6936667zm34.847167 43.5435001c1.841 4.111333 1.766333 5.989667 1.649666 6.606833-.198333 1.040667-1.107166 1.793167-2.167666 1.793167H9.24944734c-1.16666667 0-2.1315-.907667-2.2015-2.072-.33133333-5.451833 1.05583333-9.9505001 4.12183336-13.3711668 4.9186666-5.4868333 12.8321666-6.6523333 17.1115-6.86.3721666-.0186666.5716666-.196.5985-.2555.7081666-3.584 3.0286666-5.7306666 6.2043333-5.7306666 2.464 0 4.9828333 1.0243333 7.2846667 2.9656666.2998333.2508334.9158333.2461667 1.1981666-.0116666 3.1488334-2.8735 6.9556667-5.9383334 12.3013334-5.9383334.2286666 0 .4515.0093334.6743333.0256667v-15.4c-.0116667-.0046667-.0245-.0081667-.0361667-.0128333l-3.6761666-1.6018334c-6.8926667 2.4045-13.0071667 3.6073334-18.3085 3.6073334-5.8765 0-10.7543334-1.477-14.5903334-4.4298334-9.7801666-7.525-8.8141666-21.63-8.7686666-22.2261666.0781666-1.0208334.8493333-1.8526667 1.8608333-2.0113334 18.8475-2.9388333 31.5816667-.7478333 37.8478333 6.5123334 4.3831667 5.0796666 4.3435 11.1895 3.8733334 14.567l1.7978333.784V38.1627492c-1.3638333-2.4733333-5.159-10.6656666-1.1456667-19.1835 4.711-9.99949995 18.2385-16.37999995 40.2068334-18.96416662 1.0161666-.119 1.981.476 2.331 1.43733333.2356666.64866667 5.6746663 16.01599999-2.8408334 27.37933329-5.6186666 7.497-15.8223333 11.2805-30.373 11.2805-1.2238333 0-2.4815-.0303333-3.766-.0828333v28.042l.8726667-.3803333c-.2858333-2.6191667-.1248333-6.9101667 2.989-10.5186667 4.6643333-5.4028333 14.0315-7.0513333 27.839-4.8988333 1.0103333.1575 1.7803333.9893333 1.8585 2.0101666.035.4445.7525 10.9293334-6.5566667 16.5538334-2.8758333 2.212-6.517 3.3191666-10.8885 3.3191666-3.8336666 0-8.2308333-.8528333-13.1681666-2.555l-2.4325 1.0581667c-.168.0735-.3406667.1213333-.5133334.1505v9.3275c2.0043334 1.1421667 3.6353334 2.8035 4.8463334 4.3365 1.7978333-1.995 4.1895-3.1535 6.9323333-3.3553333 4.8335-.3546667 9.4593333 2.751 11.4473333 4.3073333 2.6121667-.7956667 5.3281667-1.2576667 8.3265 1.0161667.9706667.7373333 1.1596667 2.121.4235 3.0916666-.7373333.9706667-2.121 1.1608334-3.0916666.4235-1.449-1.099-2.3858334-.9648333-5.4565.035-.7583334.2473334-1.5913334.0665-2.1781667-.4736666-1.3136667-1.2016667-5.5288333-4.2688334-9.1466667-3.9993334-1.6543333.1213334-3.024.8003334-4.0728333 2.0148334-.8131667.9403333-2.0195 1.463-3.325 1.4233333-1.2798333-.035-2.4395-.6078333-3.1815-1.5691667-1.2238333-1.5878333-3.7111667-4.2513333-6.6103333-4.2513333-3.7695 0-6.5636667 2.2633333-9.3275 4.7856667-1.9285 1.7605-5.0108334 1.8153333-7.0151667.126-1.043-.8796667-2.6611667-1.9273334-4.4415-1.9273334-.469 0-1.4455 0-1.8795 2.1886667-.4211667 2.1198333-2.3578333 3.6796667-4.7098333 3.7928333-3.5933334.1738334-10.192 1.106-14.0396667 5.3981667-1.8701667 2.0860001-2.8828333 4.7996671-3.0251667 8.0850001h88.4123334c-.1936667-.582167-.4701667-1.303167-.8633334-2.182833-.4981666-1.111834 0-2.417334 1.1118337-2.914334 1.111833-.499333 2.417333-.001166 2.9155 1.110667zM55.7412307 89.9797826l.0478333.0303333c1.0208333.665 1.3113333 2.0311667.6486667 3.0531667-.4235.6498333-1.1305 1.0045-1.8526667 1.0045-.413 0-.8283333-.1155-1.2005-.3558334l-.0478333-.0315c-1.022-.6638333-1.3125-2.03-.6475-3.052.6638333-1.022 2.03-1.3125 3.052-.6486666zM36.030864 96.1862159l.0478333.0303333c1.022.6638334 1.3125 2.0311667.6498334 3.0531667-.4246667.6498333-1.1316667 1.0033331-1.8526667 1.0033331-.413 0-.8283333-.114333-1.2005-.3558331l-.0478333-.0315c-1.022-.6626667-1.3125-2.0288333-.6486667-3.0508333.6638333-1.022 2.03-1.3125 3.052-.6486667zm33.60665 1.32335l.049.0303333c1.0208333.665 1.3113333 2.0311667.6486667 3.0531668-.4235.649833-1.1305 1.0045-1.8526667 1.0045-.413 0-.8295-.1155-1.2005-.355833l-.0478333-.0315c-1.022-.663834-1.3125-2.0300004-.6475-3.0520004.6626666-1.022 2.03-1.3125 3.0508333-.6486667z"
            fill={fill}
          />
        </g>
      </svg>
    </Container>
  </React.Fragment>
)

LgaServices.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
}

LgaServices.defaultProps = {
  height: "40",
  width: "40",
  margin: "0",
  fill: `${theme.colors.black900}`,
}

export const CookieIcon = ({ height, width, margin, fill }) => (
  <React.Fragment>
    <Container margin={margin}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        width={width}
        viewBox="0 0 112 112"
      >
        <path
          fill={fill}
          fillRule="evenodd"
          d="M76.48 33.201c2.995 0 5.43-2.414 5.43-5.381s-2.435-5.38-5.43-5.38c-2.994 0-5.431 2.413-5.431 5.38S73.486 33.2 76.48 33.2zm0-15.33c5.537 0 10.042 4.463 10.042 9.949 0 5.487-4.505 9.949-10.042 9.949-5.538 0-10.043-4.462-10.043-9.95 0-5.485 4.505-9.948 10.043-9.948zM58.944 71.525c4.133 0 7.493-3.33 7.493-7.424s-3.361-7.424-7.493-7.424-7.494 3.33-7.494 7.424 3.362 7.424 7.494 7.424zm0-19.418c6.675 0 12.105 5.382 12.105 11.994s-5.43 11.994-12.105 11.994c-6.676 0-12.106-5.38-12.106-11.994s5.43-11.994 12.106-11.994zM21 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM7 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 19a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm10.583 58.562c23.172 25.975 64.547 21.984 82.41-7.328-8.208-1.927-14.214-9.19-14.214-17.877 0-10.892 9.587-19.503 20.647-18.263-6.13-30.43-38.36-48.73-68.065-37.919.732 4.7-1.336 9.35-5.179 12.025 2.074 11.053-7.358 20.847-18.52 19.433a12.454 12.454 0 0 1-8.647 4.823 50.485 50.485 0 0 0-1.293 13.12c10.966-2.23 21.198 6.109 21.198 17.128 0 6.164-3.188 11.71-8.337 14.858zm-2.927-3.596c4.091-2.264 6.653-6.516 6.653-11.262 0-8.385-7.996-14.59-16.229-12.526 1.082 8.704 4.427 16.851 9.576 23.788zm87.642-7.947c4.093-8.4 5.826-17.76 4.85-27.19-8.68-1.771-16.757 4.831-16.757 13.528 0 6.952 5.12 12.69 11.907 13.662zM84.233 103.9l-5.434 2.765C36.623 125.253-9.87 87.362 1.835 42.15c.334-1.293 1.516-2.195 2.876-2.195h.002a7.872 7.872 0 0 0 6.65-3.616 3.06 3.06 0 0 1 3.152-1.353c8.636 1.629 16.147-6.198 13.965-14.706-.344-1.338.264-2.76 1.479-3.456 2.96-1.7 4.552-5.178 3.714-8.602-.402-1.64.498-3.343 2.095-3.959C49.35-.974 64.866-.848 78.718 5.29l5.5 2.738c36.996 21.358 37.085 74.404.015 95.873z"
        />
      </svg>
    </Container>
  </React.Fragment>
)

CookieIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  fill: PropTypes.string,
}

CookieIcon.defaultProps = {
  height: "32",
  width: "32",
  margin: "0",
  fill: `${theme.colors.black900}`,
}
